export const ROLE_MASTER = 'master';
export const ROLE_ADMIN = 'admin';

const ROLE_ALIAS_MAP: Record<string, string[]> = {
  [ROLE_ADMIN]: ['administrator', 'administrador', 'admin-general'],
  [ROLE_MASTER]: ['superadmin', 'super administrator', 'super administrador', 'root'],
};

export function normalizeRoleName(roleName?: string | null): string {
  return roleName ? roleName.toLowerCase().trim() : '';
}

function resolveRoleAliases(roleName: string): string[] {
  const normalized = normalizeRoleName(roleName);
  const aliases = ROLE_ALIAS_MAP[normalized] || [];
  const normalizedAliases = aliases.map((alias) => normalizeRoleName(alias));
  return Array.from(new Set([normalized, ...normalizedAliases]));
}

export function extractRoleName(subject: any): string {
  if (!subject) {
    return '';
  }

  if (typeof subject === 'string') {
    return normalizeRoleName(subject);
  }

  if (subject.role?.name) {
    return normalizeRoleName(subject.role.name);
  }

  if (subject.roleName) {
    return normalizeRoleName(subject.roleName);
  }

  if (subject.name) {
    return normalizeRoleName(subject.name);
  }

  return '';
}

export function hasRole(subject: any, targetRole: string): boolean {
  if (!targetRole) {
    return false;
  }
  const roleName = extractRoleName(subject);
  if (!roleName) {
    return false;
  }
  const candidates = resolveRoleAliases(targetRole);
  return candidates.includes(roleName);
}

export function hasAnyRole(subject: any, roles: string[]): boolean {
  if (!roles || roles.length === 0) {
    return false;
  }
  return roles.some((role) => hasRole(subject, role));
}

export function canManageUsers(subject: any): boolean {
  return hasAnyRole(subject, [ROLE_MASTER, ROLE_ADMIN]);
}

export function isAdmin(subject: any): boolean {
  return hasRole(subject, ROLE_ADMIN);
}

export function isMaster(subject: any): boolean {
  return hasRole(subject, ROLE_MASTER);
}
